import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const TopbarMenuLinks = ({ 
  title, icon, path, openInNewTab,
}) => {
  // If openInNewTab is true, use a regular anchor tag
  if (openInNewTab) {
    return (
      <a 
        className="topbar__link" 
        href={path} 
        target="_blank" 
        rel="noopener noreferrer"
      >
        <span className={`topbar__link-icon lnr lnr-${icon}`} />
        <p className="topbar__link-title">{title}</p>
      </a>
    );
  }
  
  // Otherwise use Link for internal navigation
  return (
    <Link className="topbar__link" to={path}>
      <span className={`topbar__link-icon lnr lnr-${icon}`} />
      <p className="topbar__link-title">{title}</p>
    </Link>
  );
};

TopbarMenuLinks.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  openInNewTab: PropTypes.bool,
};

TopbarMenuLinks.defaultProps = {
  openInNewTab: false,
};

export default TopbarMenuLinks;
